import React, { useContext } from 'react'
import Workflow from './Workflow'
import { listsService, teamService } from '../services'
import { useRouter } from '../hooks'
import helpers from '../util/helpers'
import { AppContext } from '../contexts/AppContext'

const TeamWorkflow: React.FC = () => {
  const { replaceURL } = useRouter()
  const { state, dispatch } = useContext(AppContext)
  const { teamBrand } = state

  const initialData = {
    teamBrandId: teamBrand?.id,
  }

  const complete = (data: any) =>
    helpers.withLoading(async () => {
      const res = await teamService.create(data)

      dispatch({
        type: 'teamAdded',
        value: res,
      })

      replaceURL('/a/team/roster/')
    })

  return (
    <Workflow
      id="team"
      steps={[
        {
          id: 'level',
          fields: [
            {
              key: 'level',
              type: 'pick-one',
              label: 'Level',
              options: listsService.teamLevels,
              required: true,
            },
          ],
          validate: (data: any) => {
            if (!data.programType) {
              return {
                valid: false,
                message: 'Please select your team level.',
              }
            }

            return {
              valid: true,
            }
          },
          title: `Create a new team`,
          subtext: `What is the team level for the new ${teamBrand?.fullName} team? If there isn't one, just choose None.`,
          button: {
            children: 'Finish',
          },
        },
      ]}
      data={initialData}
      onComplete={complete}
    />
  )
}

export default React.memo(TeamWorkflow)
